export class MaintenanceModeError extends Error {
  constructor(message: string = 'Service is under maintenance') {
    super(message);
    this.name = 'MaintenanceModeError';
  }
} 